import React, { createContext, useContext, useState, ReactNode } from 'react';

interface CaseContextType {
  currentCaseId: string | null;
  setCurrentCaseId: (id: string | null) => void;
  caseTitle: string | null;
  setCaseTitle: (title: string | null) => void;
  caseData: Record<string, any> | null;
  setCaseData: (data: Record<string, any> | null) => void;
  oliviaSidebarOpen: boolean;
  toggleOliviaSidebar: () => void;
}

const CaseContext = createContext<CaseContextType | undefined>(undefined);

export const CaseProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [currentCaseId, setCurrentCaseId] = useState<string | null>(null);
  const [caseTitle, setCaseTitle] = useState<string | null>(null);
  const [caseData, setCaseData] = useState<Record<string, any> | null>(null);
  const [oliviaSidebarOpen, setOliviaSidebarOpen] = useState<boolean>(false);

  const toggleOliviaSidebar = () => {
    setOliviaSidebarOpen(!oliviaSidebarOpen);
  };

  const value = {
    currentCaseId,
    setCurrentCaseId,
    caseTitle,
    setCaseTitle,
    caseData,
    setCaseData,
    oliviaSidebarOpen,
    toggleOliviaSidebar
  };

  return <CaseContext.Provider value={value}>{children}</CaseContext.Provider>;
};

export const useCase = (): CaseContextType => {
  const context = useContext(CaseContext);
  
  // Instead of throwing, provide a fallback context
  if (context === undefined) {
    console.warn('useCase hook used outside of a CaseProvider - using fallback context');
    // Return a non-functioning fallback to prevent errors
    return {
      currentCaseId: null,
      setCurrentCaseId: () => {},
      caseTitle: null,
      setCaseTitle: () => {},
      caseData: null,
      setCaseData: () => {},
      oliviaSidebarOpen: false,
      toggleOliviaSidebar: () => {}
    };
  }
  
  return context;
};